import axios from 'axios';

import { SET_TAGS, ADD_TAG } from './types';
import { util as customerUtil } from '@/slices/customerSlice';

// tags: string[]
export const setTags =
	({ tags }) =>
	async (dispatch) => {
		dispatch({ type: SET_TAGS, payload: tags });
	};

export const addNewTagToTagList =
	({ newTag }) =>
	async (dispatch) => {
		dispatch({ type: ADD_TAG, payload: newTag });
	};

export const getAllTags =
	(isEnterpriseRequested = false) =>
	async (dispatch) => {
		const res = await axios.get(
			`/api/tags/list?isEnterpriseRequested=${isEnterpriseRequested}`
		);

		const { data } = res;

		if (!data) {
			return;
		}

		const { allTags } = data;

		dispatch({ type: SET_TAGS, payload: allTags });
	};

// Bulk update customer tags with proper cache invalidation
export const bulkUpdateCustomerTags =
	({ customerIds, tags }) =>
	async (dispatch) => {
		try {
			// Call the main API (not runner API) to update customer tags
			const res = await axios.post('/api/update-customers-tags', {
				_customers: customerIds,
				tags: tags,
			});

			if (res.data.error) {
				throw new Error('Failed to update customer tags');
			}

			// Invalidate RTK Query customer cache to trigger refetch
			dispatch(
				customerUtil.invalidateTags([
					{ type: 'Customer', id: 'LIST' },
					...customerIds.map((_customer) => ({
						type: 'Customer',
						id: _customer,
					})),
				])
			);

			return { success: true };
		} catch (error) {
			console.error('Error updating customer tags:', error);
			throw error;
		}
	};

// Adds or removes one tag on the server, so tags other users added meanwhile are kept
export const toggleCustomerTag =
	({ _customer, tag, isAdding, _business }) =>
	async (dispatch) => {
		try {
			const res = await axios.post('/api/update-customer-tags', {
				_customer,
				tag,
				isAdding,
				_business,
			});

			if (!res.data || res.data.error) {
				throw new Error('Failed to update customer tags');
			}

			dispatch(
				customerUtil.invalidateTags([
					{ type: 'Customer', id: 'LIST' },
					{ type: 'Customer', id: _customer },
				])
			);

			return { success: true, customer: res.data.customer };
		} catch (error) {
			console.error('Error updating customer tags:', error);
			throw error;
		}
	};

// Get detailed tag list with customer counts for tag manager
export const getDetailedTagList = async () => {
	const res = await axios.post('/api/tag-manager/get-detailed-tag-list');

	const { data } = res;

	if (!data || data.error) {
		throw new Error(data?.message || 'Failed to get detailed tag list');
	}

	return data.detailedTags;
};

// Add a new tag to the tag manager
export const addTagToManager =
	({ tag }) =>
	async (dispatch) => {
		const res = await axios.post('/api/tag-manager/add-tag', { tag });

		const { data } = res;

		if (!data || data.error) {
			throw new Error(data?.message || 'Failed to add tag');
		}

		const { allTags } = data;

		dispatch({ type: SET_TAGS, payload: allTags });

		return { success: true, addedTag: data.addedTag };
	};

// Delete tags from tag manager (removes from all customers)
export const deleteTagsFromManager =
	({ tags }) =>
	async (dispatch) => {
		const res = await axios.post('/api/tag-manager/delete-tags', { tags });

		const { data } = res;

		if (!data || data.error) {
			throw new Error(data?.message || 'Failed to delete tags');
		}

		// Fetch the updated tag list
		const listRes = await axios.get('/api/tags/list');

		if (listRes.data && listRes.data.allTags) {
			dispatch({ type: SET_TAGS, payload: listRes.data.allTags });
		}

		return { success: true };
	};
